import { Component, OnInit, Input } from '@angular/core';
import { QueryVhweb} from 'private-angular-vhframeworks'
@Component({
  selector: 'app-customers-products',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {
  list_selected_customer:any;
  @Input() id_parent : any ;
  constructor(
    private queryVhweb:QueryVhweb
  ) { }
  
  ngOnInit() {
    this.get_selectCustomer();
    
  }

  get_selectCustomer(){
    this.queryVhweb.getSelectedProducts("customers-said",this.id_parent)
    .then(res=>{
      
      this.list_selected_customer = res.docs.map(item =>{
        return {id:item.id,...item.data()}
      })
      
    })
  }

}
